/**
 * PublicLayout - פריסת עמודים ציבוריים
 * Wraps unauthenticated pages (login, register, etc.) with a skip link and a
 * <main> landmark so keyboard/screen-reader users get the same bypass-blocks
 * and landmark structure as the authed area. Adds no visual box — the pages
 * keep their own full-screen layouts. WCAG 2.4.1 / 1.3.1.
 *
 * `withFooter` adds the same bottom menu the authed area has (legal links +
 * install guide). It is opt-in per route because most public pages here are
 * single-purpose forms; the front door at "/" uses it.
 */

import { Outlet } from 'react-router-dom'
import SkipLink from './SkipLink'
import Footer from './Footer'

interface PublicLayoutProps {
  withFooter?: boolean
}

export default function PublicLayout({ withFooter = false }: PublicLayoutProps) {
  return (
    <div className="flex min-h-screen flex-col">
      <SkipLink />
      <main id="main-content" className="flex-1">
        <Outlet />
      </main>
      {withFooter && <Footer />}
    </div>
  )
}
